export default __webpack_public_path__ + "static/media/slide2.70dc135a.webp";